<template>
  <AppDialog
    class="manage-selections-dialog"
    :title="`${fieldName} options`"
    :show="show"
    subtitle="This will update selection choices in all member profiles"
    append-to-body
    @close="close"
  >
    <form
      ref="form"
      tabindex="-1"
    >
      <div
        v-for="(selection, index) in fieldSelections"
        :key="selection.id"
        class="form-group"
      >
        <label class="control-label">{{ fieldName }} {{ index + 1 }}</label>
        <div class="d-flex align-items-center gap-10">
          <AppInput
            :value="selection.title"
            readonly
          />
          <i
            class="hi hi-edit hi-12 text-blue clickable"
            @click="showSelectionDialog({ ...selection, position: index + 1, availablePositions: positionOptions })"
          />
        </div>
      </div>
      <div
        class="text-blue clickable strong d-flex align-items-center add-option gap-5"
        @click="showSelectionDialog(newSelection)"
      >
        <i class="hi hi-plus hi-10" />
        Add option
      </div>
      <div class="footer">
        <div class="d-flex mt-40">
          <div class="ml-auto">
            <AppButton
              type="default"
              @click="close"
            >
              Close
            </AppButton>
          </div>
        </div>
      </div>
    </form>
  </AppDialog>
</template>

<script>
export default {
  name: 'MemberProfileManageSelectionsDialog',
  props: {
    show: {
      type: Boolean,
      default: true,
    },
    field: {
      type: String,
      required: true,
    },
    fieldSelections: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    totalSelections() {
      return Object.keys(this.fieldSelections).length;
    },
    positionOptions() {
      return Array.from({ length: this.totalSelections }, (_, i) => ({ text: `Position ${i + 1}`, id: i + 1 }));
    },
    newSelection() {
      const newPosition = this.totalSelections + 1;

      return {
        position: newPosition,
        availablePositions: [...this.positionOptions, { text: `Position ${newPosition}`, id: newPosition }],
      };
    },
    fieldName() {
      return this.field.replace(/_/g, ' ');
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.form.focus();
    });
  },
  methods: {
    close() {
      this.$emit('close');
    },
    showSelectionDialog(selection) {
      this.$emit('open-selection', selection);
    },
  },
};
</script>
